import { useId } from 'react';

export const ConfluenceIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  const id = useId();
  const a = `${id}-a`;
  const b = `${id}-b`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.04395 13.9521C2.88881 14.2154 2.71458 14.5209 2.56661 14.7644C2.43416 14.9973 2.50526 15.2977 2.72651 15.44L5.82923 17.4271C5.93814 17.4971 6.0695 17.5186 6.19381 17.4868C6.31811 17.4551 6.42496 17.3727 6.49035 17.2582C6.61446 17.0421 6.77437 16.7614 6.9486 16.4608C8.17775 14.3496 9.41406 14.6079 11.6432 15.7157L14.7197 17.2383C14.8362 17.296 14.9702 17.3022 15.0912 17.2554C15.2121 17.2086 15.3097 17.1128 15.3617 16.9899L16.8391 13.5125C16.9435 13.2641 16.8373 12.9745 16.6004 12.8617C15.9513 12.5438 14.66 11.9104 13.4977 11.3267C9.31621 9.21289 5.7624 9.3495 3.04395 13.9521Z"
        fill={`url(#${a})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9542 6.05969C17.1093 5.7964 17.2836 5.49088 17.4315 5.24746C17.564 5.01453 17.4929 4.71411 17.2716 4.57185L14.1689 2.58475C14.0591 2.50778 13.9235 2.48173 13.7946 2.51281C13.6656 2.54389 13.5548 2.62932 13.4887 2.74868C13.3646 2.96478 13.2047 3.24546 13.0305 3.54601C11.8013 5.6573 10.565 5.39898 8.3358 4.29117L5.26888 2.776C5.15237 2.71829 5.01836 2.71212 4.89741 2.75892C4.77645 2.80572 4.67886 2.90148 4.62686 3.02439L3.14949 6.50182C3.04511 6.75018 3.15132 7.03978 3.38816 7.1526C4.03734 7.47054 5.32855 8.10392 6.49088 8.68764C10.6819 10.7989 14.2357 10.6574 16.9542 6.05969Z"
        fill={`url(#${b})`}
      />
      <defs>
        <linearGradient id={a} x1="16.7556" y1="18.4529" x2="13.0416" y2="10.2659" gradientUnits="userSpaceOnUse">
          <stop offset="0.18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient id={b} x1="3.24257" y1="1.55642" x2="6.96236" y2="9.74723" gradientUnits="userSpaceOnUse">
          <stop offset="0.18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
